import React from "react";
import { Helmet } from "react-helmet";
import { Image, Spinner } from "react-bootstrap";

import { useInvitationLogic } from "../../hooks";
import {
    InvitationAcceptanceForm,
    LogoutModal,
    LoginModal,
    ErrorDisplay
} from "../../components/ui/AcceptInvitation";

type AcceptInvitationPageProps = {
    id: string;
};

const AcceptInvitationPage: React.FC<AcceptInvitationPageProps> = ({ id }) => {
    const {
        isLoading,
        inviteAcceptance,
        errorMessage,
        showLogout,
        showLogin,
        email,
        logout,
        setShowLogout,
        setShowLogin
    } = useInvitationLogic(id);

    if (isLoading) {
        return (
            <div className="login-page p-3 d-flex align-items-center justify-content-center min-vh-100">
                <Spinner animation="border" />
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <title>Accept Invitation</title>
            </Helmet>
            <div className="login-page p-3">
                <div className="login-brand-section">
                    <Image
                        src="/images/froom-waste-tracker-logo.svg"
                        className="login-brand-logo h-20rem froom-brand"
                        alt="Froom Waste Tracker"
                    />
                    <Image
                        src="/images/waste-tracking-system-strapline.png"
                        alt="Froom waste tracking system"
                        className="login-strapline-image"
                    />
                </div>

                <div className="login-form-container">
                    <h1 className="password-title">Accept Invitation</h1>
                    <p>
                        This page is for accepting an invitation to use Froom Waste Tracker
                        software. Please enter your name as you would like it to be shown in
                        the software and a password below to create a user account.
                    </p>
                    {inviteAcceptance && (
                        <InvitationAcceptanceForm
                            inviteAcceptance={inviteAcceptance}
                        />
                    )}
                    {!inviteAcceptance && (
                        <ErrorDisplay
                            errorMessage={errorMessage}
                            onLogout={logout}
                        />
                    )}
                </div>
            </div>

            <LogoutModal
                show={showLogout}
                errorMessage={errorMessage}
                onLogout={logout}
            />

            <LoginModal
                show={showLogin}
                email={email}
            />
        </>
    );
};

export { AcceptInvitationPage };
